// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2HHQh","calendarButtons":"ClockData_calendarButtons__wFWtn"};